<template>
  <main>
    <back url="/dashboard/talents" />

    <div class="flex items-center justify-between mb-7 mt-8 px-2 md:px-0">
      <div>
        <h1 class="capitalize text-[18px] font-bold">Talent details</h1>
        <div class="flex items-center mt-2">
          <span class="capitalize inline-block text-light-gray text-[13px]">talents</span>
          <img src="@/assets/icons/chevron-right.svg" class="mx-2" alt="" />
          <span class="capitalize inline-block text-brand-black text-[13px]">details</span>
        </div>
      </div>

      <div></div>
    </div>

    <div class="p-3 rounded-lg bg-white mb-10">
      <div class="block md:flex items-start gap-x-6 justify-between">
        <div class="w-full md:w-4/12 border border-grey-1 rounded-sm mb-6 md:mb-0">
          <div class="p-4 border-b border-grey-1 flex flex-col items-center pt-4 mb-0.5">
            <img
              :src="talent?.avatar"
              alt=""
              class="rounded-full w-28 h-28"
              style="
                background-image: url('/avatarmale.jpeg');
                background-size: cover;
                background-repeat: no-repeat;
              "
            />

            <h6 class="mt-4 mb-0 text-lg text-gray-900 dark:text-gray-50">{{ talent?.user?.name }}</h6>
            <p class="mb-4 text-gray-500 dark:text-gray-300 capitalize">{{ talent?.role_title }}</p>

            <div class="flex justify-center items-center gap-x-2 mb-6">
              <div>
                <star-rating
                  v-model:rating="talent.profile_rating"
                  :starSize="20"
                  :disableClick="true"
                  starColor="#FDD836"
                  inactiveColor="#D8D8D8"
                  :show-rating="false"
                />
              </div>
              <span class="inline-block text-sm mt-1">{{ talent?.profile_rating }}</span>
            </div>

            <ul class="flex justify-center gap-4">
              <li class="h-10 w-10 text-center flex justify-center items-center bg-gray-100 rounded-full text-lg text-gray-500">
                <a :href="linkedin_url" target="_blank" class="social-link" v-tooltip.top="'Linkedin'">
                  <RiLinkedinFill size="20" />
                </a>
              </li>
              <li class="h-10 w-10 text-center flex justify-center items-center bg-gray-100 rounded-full text-lg text-gray-500" v-if="github">
                <a :href="github" target="_blank" class="social-link" v-tooltip.top="'Github'">
                  <RiGithubLine size="20" />
                </a>
              </li>
              <li class="h-10 w-10 text-center flex justify-center items-center bg-gray-100 rounded-full text-lg text-gray-500" v-if="dribbble">
                <a :href="dribbble" target="_blank" class="social-link" v-tooltip.top="'Dribbble'">
                  <RiDribbbleLine size="20" />
                </a>
              </li>
              <li class="h-10 w-10 text-center flex justify-center items-center bg-gray-100 rounded-full text-lg text-gray-500" v-if="behance">
                <a :href="behance" target="_blank" class="social-link" v-tooltip.top="'Behance'">
                  <RiBehanceFill size="20" />
                </a>
              </li>
              <li class="h-10 w-10 text-center flex justify-center items-center bg-gray-100 rounded-full text-lg text-gray-500">
                <a :href="website" target="_blank" class="social-link" v-tooltip.top="'Website'">
                  <RiLink size="20" />
                </a>
              </li>
            </ul>
          </div>

          <div class="p-5 border-b border-grey-1">
            <h6 class="mb-5 font-semibold text-gray-900 text-xl dark:text-gray-50">Profile Overview</h6>
            <ul class="space-y-4">
              <li>
                <div class="flex">
                  <label class="text-gray-900 w-[118px] font-medium dark:text-gray-50">Availability</label>
                  <div>
                    <p class="mb-0 text-gray-500 dark:text-gray-300 capitalize">{{ talent?.job_preference?.availability_status }}</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="flex">
                  <label class="text-gray-900 w-[118px] font-medium dark:text-gray-50">Offered Salary</label>
                  <div>
                    <p class="mb-0 text-gray-500 dark:text-gray-300">
                      {{ currencySymbol(talent?.job_preference?.desired_salary_currency)
                      }}{{ Math.ceil(intNum(talent?.job_preference?.desired_salary) / 2080) }} per hour
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="flex">
                  <label class="text-gray-900 w-[118px] font-medium dark:text-gray-50">Languages</label>
                  <div>
                    <p class="mb-0 text-gray-500 dark:text-gray-300">English</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="flex">
                  <label class="text-gray-900 w-[118px] font-medium dark:text-gray-50">Experience</label>
                  <div>
                    <p class="mb-0 text-gray-500 dark:text-gray-300">{{ talent?.years_of_experience }} Years</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="flex">
                  <label class="text-gray-900 w-[118px] font-medium dark:text-gray-50">Qualification</label>
                  <div>
                    <p class="mb-0 text-gray-500 dark:text-gray-300">College / Degree</p>
                  </div>
                </div>
              </li>
              <!-- <li>
                <div class="flex">
                  <label class="text-gray-900 w-[118px] font-medium dark:text-gray-50">Views</label>
                  <div>
                    <p class="mb-0 text-gray-500 dark:text-gray-300">2574</p>
                  </div>
                </div>
              </li> -->
            </ul>
            <div class="mt-8">
              <a
                :href="linkedin_url"
                target="_blank"
                class="flex justify-center items-center gap-x-2 p-3 rounded-md w-full bg-brand-black shadow-md border-transparent text-white hover:-translate-y-1.5 transition-all text-center mb-3"
                ><RiPhoneLine size="20" /> Contact</a
              >
              <a
                :href="talent?.resume"
                target="_blank"
                class="flex justify-center items-center gap-x-2 p-3 rounded-md w-full bg-white border border-gray-300 shadow-md text-brand-black hover:-translate-y-1.5 transition-all text-center"
                ><RiDownload2Line size="20" /> Download CV</a
              >
            </div>
          </div>

          <div class="p-5 border-b border-gray-100/50 dark:border-neutral-600">
            <h6 class="mb-3 font-semibold text-gray-900 text-xl dark:text-gray-50">Open to (Job types)</h6>
            <div class="flex flex-wrap gap-2">
              <span
                class="px-2 py-1 font-medium text-green-500 rounded bg-green-400/20 text-13 capitalize"
                v-for="(item, i) in talent?.job_preference?.job_types"
                :key="i"
                >{{ item }}</span
              >
            </div>
          </div>

          <div class="p-5 border-b border-gray-100/50 dark:border-neutral-600">
            <h6 class="mb-3 font-semibold text-gray-900 text-xl dark:text-gray-50">Professional Skills</h6>
            <div class="flex flex-wrap gap-2">
              <span
                class="px-2 py-1 font-medium text-green-500 rounded bg-green-400/20 text-13 capitalize"
                v-for="(item, i) in talent?.skills"
                :key="i"
                >{{ item }}</span
              >
            </div>
          </div>

          <div class="p-5 border-b border-gray-100/50 dark:border-neutral-600">
            <h6 class="mb-3 font-semibold text-gray-900 text-xl dark:text-gray-50">Next Role Perks</h6>
            <div class="flex flex-wrap gap-2">
              <span
                class="px-2 py-1 font-medium text-green-500 rounded bg-green-400/20 text-13 capitalize"
                v-for="(item, i) in talent?.job_preference?.next_role_perks"
                :key="i"
                >{{ item }}</span
              >
            </div>
          </div>

          <div class="p-5">
            <h6 class="mb-3 font-semibold text-gray-900 text-xl dark:text-gray-50">Contact Details</h6>
            <ul>
              <li>
                <div class="flex items-center gap-x-3 mt-4">
                  <div class="bg-gray-100 h-11 w-11 rounded-full flex items-center justify-center">
                    <RiMailLine size="20" />
                  </div>
                  <div class="ltr:ml-3 rtl:mr-3">
                    <h6 class="text-gray-900 text-14 dark:text-gray-50">Email</h6>
                    <p class="text-gray-500 dark:text-gray-300">{{ talent?.user?.email }}</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="flex items-center gap-x-3 mt-4">
                  <div class="bg-gray-100 h-11 w-11 rounded-full flex items-center justify-center">
                    <RiMapPin2Line size="20" />
                  </div>
                  <div class="ltr:ml-3 rtl:mr-3">
                    <h6 class="text-gray-900 text-14 dark:text-gray-50">Address</h6>
                    <p class="text-gray-500 dark:text-gray-300">{{ talent?.address?.state }} - {{ talent?.address?.country_name }}</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="flex items-center gap-x-3 mt-4">
                  <div class="bg-gray-100 h-11 w-11 rounded-full flex items-center justify-center">
                    <RiPhoneLine size="20" />
                  </div>
                  <div class="ltr:ml-3 rtl:mr-3">
                    <h6 class="text-gray-900 text-14 dark:text-gray-50">Phone</h6>
                    <p class="text-gray-500 dark:text-gray-300">{{ talent?.phone_number }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="flex-1 border border-grey-1 rounded-sm p-6">
          <div>
            <h6 class="mb-3 text-gray-900 text-xl dark:text-gray-50">About Me</h6>
            <p class="mb-2 text-gray-500 dark:text-gray-300">{{ talent?.bio || 'No bio information for this talent yet' }}.</p>
          </div>

          <div class="pt-5">
            <h6 class="mb-0 text-gray-900 text-xl fw-bold dark:text-gray-50">Education</h6>
            <div class="relative flex mt-4" v-for="(item, i) in talent?.educations" :key="i">
              <div
                class="h-8 w-8 text-center leading-[2.2] group-data-[theme-color=violet]:bg-violet-500/20 group-data-[theme-color=sky]:bg-sky-500/20 group-data-[theme-color=red]:bg-red-500/20 group-data-[theme-color=green]:bg-green-500/20 group-data-[theme-color=pink]:bg-pink-500/20 group-data-[theme-color=blue]:bg-blue-500/20 group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=sky]:text-sky-500 group-data-[theme-color=red]:text-red-500 group-data-[theme-color=green]:text-green-500 group-data-[theme-color=pink]:text-pink-500 group-data-[theme-color=blue]:text-blue-500 shrink-0 rounded-full font-medium text-violet-500"
              >
                {{ item.field_of_study[0] }}
              </div>
              <div
                class="after:contant[''] after:border after:absolute after:h-24 ltr:after:left-4 rtl:after:right-4 after:top-10 after:border-dashed group-data-[theme-color=violet]:after:border-violet-500/30 group-data-[theme-color=sky]:after:border-sky-500/30 group-data-[theme-color=red]:after:border-red-500/30 group-data-[theme-color=green]:after:border-green-500/30 group-data-[theme-color=pink]:after:border-pink-500/30 group-data-[theme-color=blue]:after:border-blue-500/30 hidden md:block"
              ></div>

              <div class="space-y-6 ltr:ml-4 rtl:mr-4">
                <div>
                  <h6 class="mb-1 text-gray-900 text-16 dark:text-gray-50">{{ item.field_of_study }}</h6>
                  <p class="mb-2 text-gray-500 dark:text-gray-300">
                    {{ item.school_name }} - ({{ getCurrentYear(item.start_date) }} - {{ getCurrentYear(item.end_date) }})
                  </p>
                  <p class="text-gray-500 dark:text-gray-300">Description not found</p>
                </div>
              </div>
            </div>
          </div>

          <div class="pt-10">
            <h6 class="mb-0 text-gray-900 text-xl fw-bold dark:text-gray-50">Experience</h6>
            <div class="relative flex mt-4" v-for="(item, i) in talent?.experiences" :key="i">
              <div
                class="h-8 w-8 text-center leading-[2.2] group-data-[theme-color=violet]:bg-violet-500/20 group-data-[theme-color=sky]:bg-sky-500/20 group-data-[theme-color=red]:bg-red-500/20 group-data-[theme-color=green]:bg-green-500/20 group-data-[theme-color=pink]:bg-pink-500/20 group-data-[theme-color=blue]:bg-blue-500/20 group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=sky]:text-sky-500 group-data-[theme-color=red]:text-red-500 group-data-[theme-color=green]:text-green-500 group-data-[theme-color=pink]:text-pink-500 group-data-[theme-color=blue]:text-blue-500 shrink-0 rounded-full font-medium text-violet-500"
              >
                {{ item.title[0] }}
              </div>
              <div
                class="after:contant[''] after:border after:absolute after:h-24 ltr:after:left-4 rtl:after:right-4 after:top-10 after:border-dashed group-data-[theme-color=violet]:after:border-violet-500/30 group-data-[theme-color=sky]:after:border-sky-500/30 group-data-[theme-color=red]:after:border-red-500/30 group-data-[theme-color=green]:after:border-green-500/30 group-data-[theme-color=pink]:after:border-pink-500/30 group-data-[theme-color=blue]:after:border-blue-500/30 hidden md:block"
              ></div>
              <div class="space-y-6 ltr:ml-4 rtl:mr-4">
                <div>
                  <h6 class="mb-1 text-gray-900 text-16 dark:text-gray-50 capitalize">{{ item.title }}</h6>
                  <p class="mb-2 text-gray-500 dark:text-gray-300">
                    {{ item.company_name }} - ({{ getCurrentYear(item.start_date || item.started_at) }} -
                    {{ getCurrentYear(item.end_date || item.ended_at) }})
                  </p>
                  <p class="text-gray-500 dark:text-gray-300">{{ item.description }}.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="pt-10 mb-6">
            <h6 class="mb-0 text-gray-900 text-xl fw-bold dark:text-gray-50">Projects</h6>
            <div class="mt-4">
              <div class="grid grid-cols-12 gap-5">
                <project-card v-for="item in talent?.projects" :key="item" :project="item" />
              </div>
            </div>
          </div>

          <div class="relative h-[600px] rounded-lg overflow-hidden">
            <iframe
              src="/files/default.pdf"
              id="resumeFrame"
              frameborder="0"
              class="absolute block top-0 left-0 right-0 bottom-0 w-[100%] h-[700px] pb-80"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import moment from 'moment';
import { useStore } from 'vuex';
import { currencySymbol, intNum, saveResumeUrl } from '@/utils/helper';
import ApplicationCard from '@/components/talent/ApplicationCard.vue';
import TamButton from '@/components/TamButton.vue';
import SubHeader from '@/components/AdminSubHeader.vue';
import affiliate from '@/assets/images/affiliate.png';
import { RiPhoneLine, RiMapPin2Line, RiMailLine, RiDownload2Line, RiLinkedinFill, RiDribbbleLine, RiBehanceFill, RiLink } from '@remixicon/vue';
import ProjectCard from '@/components/talent/ProjectCard.vue';
import Back from '@/components/BackButton.vue';

const route = useRoute();
const store = useStore();
const talent = ref({});

const linkedin_url = computed(() => {
  const platform = talent.value?.social_links?.find((item) => item.platform == 'linkedin');
  return platform?.url || '';
});

const dribbble = computed(() => {
  const platform = talent.value?.social_links?.find((item) => item.platform == 'dribbble');
  return platform?.url || '';
});

const behance = computed(() => {
  const platform = talent.value?.social_links?.find((item) => item.platform == 'behance');
  return platform?.url || '';
});

const github = computed(() => {
  const platform = talent.value?.social_links?.find((item) => item.platform == 'github');
  return platform?.url || '';
});

const website = computed(() => {
  const platform = talent.value?.social_links?.find((item) => item.platform == 'website');
  return platform?.url || '';
});

const resume_label = computed(() => `${talent.value?.name?.split(' ')?.join('_')}_CV`);

const resumeUrl = computed(() => {
  return talent.value?.resume || '/files/default.pdf';
});

const getPdfUrl = () => {
  if (!resumeUrl.value) return;
  document.querySelector('#resumeFrame').src = resumeUrl.value;
};

const getCurrentYear = (dateStr) => {
  return new Date(dateStr).getFullYear();
};

const getDetail = async () => {
  talent.value = await store.dispatch('global/getSingleTalent', route.params.id);
  getPdfUrl();
};

const getSubscriptionPayments = async () => {
  loading.value = true;
  try {
    const result = await store.dispatch('global/getSubscriptionPayments');
  } catch (error) {
    toast.error(errorMessage(error), {
      timeout: 3000,
      hideProgressBar: true,
    });
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  try {
    document.querySelector('#resumeFrame').style.height = '980px';
    await Promise.all([getDetail(), getSubscriptionPayments()]);
  } catch (error) {}
});
</script>

<style scoped lang="scss"></style>
